module.exports = __webpack_public_path__ + "media/application/images/icons/thumbup-outline-9b3ec227484009c55c998639b865f4a2.svg";